import { AdbPacket, AdbPacketSerializeStream } from "@yume-chan/adb";
import { DuplexStreamFactory, ReadableStream, StructDeserializeStream, WritableStream, pipeFrom, } from "@yume-chan/stream-extra";
export default class AdbWsBackend {
    serial;
    name;
    constructor(url, name) {
        this.serial = url;
        this.name = name;
    }
    async connect() {
        const socket = new WebSocket(this.serial);
        socket.binaryType = "arraybuffer";
        await new Promise((resolve, reject) => {
            socket.onopen = resolve;
            socket.onerror = () => {
                reject(new Error("WebSocket connect failed"));
            };
        });
        const factory = new DuplexStreamFactory({
            close: () => {
                socket.close();
            },
        });
        socket.onclose = () => {
            factory.dispose().catch((e) => {
                void e;
            });
        };
        const readable = factory.wrapReadable(new ReadableStream({
            start: (controller) => {
                socket.onmessage = ({ data, }) => {
                    controller.enqueue(new Uint8Array(data));
                };
            },
        }, {
            highWaterMark: 16 * 1024,
            size(chunk) {
                return chunk.byteLength;
            },
        }));
        const writable = factory.createWritable(new WritableStream({
            write: (chunk) => {
                socket.send(chunk);
            },
        }, {
            highWaterMark: 16 * 1024,
            size(chunk) {
                return chunk.byteLength;
            },
        }));
        return {
            readable: readable.pipeThrough(new StructDeserializeStream(AdbPacket)),
            writable: pipeFrom(writable, new AdbPacketSerializeStream()),
        };
    }
}
//# sourceMappingURL=index.js.map